export enum ParticipantFormType {
  MainBooker = 'MainBooker',
  Adult = 'Adult',
  Baby = 'Baby',
  Child = 'Child',
}
